import React from 'react';
import { useSelector } from 'react-redux';
import {
  SharedTemplateAboutModal,
  SharedTemplateDeleteModal,
  SharedTemplateDuplicateModal,
  SharedTemplateEditModal,
  SharedTemplateSaveModal,
  SharedTemplateShareModal,
  SharedTemplateTriOptionModal,
  SharedTemplateUnsavedModal,
} from '../presentational/sharedTemplateComponents';

const ForcePlateTemplateModals = () => {
  const fpAboutModalShowing = useSelector(
    (state) => state.forcePlateDashboard.ui.aboutModalShowing,
  );
  const fpDeleteModalShowing = useSelector(
    (state) => state.forcePlateDashboard.ui.deleteModalShowing,
  );
  const fpDuplicateModalShowing = useSelector(
    (state) => state.forcePlateDashboard.ui.duplicateModalShowing,
  );
  const fpEditModalShowing = useSelector(
    (state) => state.forcePlateDashboard.ui.editModalShowing,
  );
  const fpSaveModalShowing = useSelector(
    (state) => state.forcePlateDashboard.ui.saveModalShowing,
  );
  const fpShareModalShowing = useSelector(
    (state) => state.forcePlateDashboard.ui.shareModalShowing,
  );
  const fpTriOptionModalShowing = useSelector(
    (state) => state.forcePlateDashboard.ui.triOptionModalShowing,
  );
  const unsavedFPDashModalShowing = useSelector(
    (state) => state.forcePlateDashboard.ui.unsavedModalShowing,
  );

  return (
    <>
      {fpAboutModalShowing && (
        <SharedTemplateAboutModal dashboard='Force Plate' />
      )}
      {fpDeleteModalShowing && (
        <SharedTemplateDeleteModal
          dashboard='Force Plate'
          legacyName='Force Plate'
        />
      )}
      {fpDuplicateModalShowing && (
        <SharedTemplateDuplicateModal
          dashboard='Force Plate'
          legacyName='Force Plate'
        />
      )}
      {fpEditModalShowing && (
        <SharedTemplateEditModal
          dashboard='Force Plate'
          legacyName='Force Plate'
        />
      )}
      {fpSaveModalShowing && (
        <SharedTemplateSaveModal
          dashboard='Force Plate'
          legacyName='Force Plate'
        />
      )}
      {fpShareModalShowing && (
        <SharedTemplateShareModal
          dashboard='Force Plate'
          legacyName='Force Plate'
        />
      )}
      {fpTriOptionModalShowing && (
        <SharedTemplateTriOptionModal
          dashboard='Force Plate'
          legacyName='Force Plate'
        />
      )}
      {unsavedFPDashModalShowing && (
        <SharedTemplateUnsavedModal
          dashboard='Force Plate'
          legacyName='Force Plate'
        />
      )}
    </>
  );
};

export default ForcePlateTemplateModals;
